export default __webpack_public_path__ + "static/media/successFlowers.714b70ce.png";